import { render, staticRenderFns } from "./CustomizationOfferEditAdmin.vue?vue&type=template&id=0029fa44&scoped=true"
import script from "./CustomizationOfferEditAdmin.vue?vue&type=script&lang=js"
export * from "./CustomizationOfferEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0029fa44",
  null
  
)

export default component.exports